import * as React from 'react';
import { useSelector } from 'react-redux';
import { IconPhone16 } from '@cian/ui-kit';
import { trackShowPhone } from '../../services';
import { Header as HeaderComponent } from '../../components/Header';
import { SPThemeWrapper } from '../../components/SPThemeWrapper';
import { checkFsk, getDeveloperName } from '../../selectors';
import { Call } from '../Call';
import { CallbackButtonContainer } from '../CallbackButton';

interface IHeaderProps {
  isFixed: boolean;
}

export const Header = ({ isFixed }: IHeaderProps) => {
  const developerName = useSelector(getDeveloperName);
  const isFsk = useSelector(checkFsk);
  const name = `Застройщик ${developerName}`;

  return (
    <HeaderComponent
      name={name}
      isFixed={isFixed}
      call={
        <SPThemeWrapper theme={isFsk ? 'fsk_fill_primary' : undefined}>
          <Call
            onShowPhone={trackShowPhone('Open_card_builder_blockStickytop')}
            showPhoneStyles={{ fullWidth: true, size: 'XS', beforeIcon: <IconPhone16 color="white_100" /> }}
            openContactsStyles={{ fullWidth: true, size: 'XS' }}
          />
        </SPThemeWrapper>
      }
      callback={
        <CallbackButtonContainer
          customTheme={isFsk ? 'fsk_fill_secondary' : undefined}
          fullWidth={true}
          place="blockStickytop"
          size="XS"
          theme="fill_secondary"
        />
      }
    />
  );
};
